import { CANVAS_HEIGHT, CANVAS_WIDTH } from "../../../config/config";

export const renderPetName = async (ctx, canvas, selectedFrame, petName, customPetNameColor, customPetNamePosition) => {

  const petNamePositions = {
    default: 160,
    upper: 130,
    top: 100,
    bottom: 320,
  };

  let originalOffsetY;
  if(customPetNamePosition){
    originalOffsetY = petNamePositions[customPetNamePosition];
  }else{
    originalOffsetY = petNamePositions[selectedFrame?.petNamePosition ?? 'default'] ?? 160;
  }
  const textOffsetY = (originalOffsetY / CANVAS_HEIGHT) * canvas.height;

  const textX = canvas.width / 2;
  const textY = textOffsetY;

  const maxFontSize = 68 * (canvas.width / CANVAS_WIDTH);
  const minFontSize = 30 * (canvas.width / CANVAS_WIDTH);
  const boundingBoxWidth = canvas.width * 0.4;

  ctx.textAlign = "center";
  if(customPetNameColor){
    ctx.fillStyle = customPetNameColor;
  }else{
    ctx.fillStyle = selectedFrame?.theme === "Dark" ? "white" : "black";
  }

  let fontSize = maxFontSize;
  while (fontSize >= minFontSize) {
    ctx.font = `400 ${fontSize}px Mitr`;
    const textWidth = ctx.measureText(petName).width;
    if (textWidth <= boundingBoxWidth) break;
    fontSize -= 1;
  }

  await document.fonts.load("400 48px 'Mitr'");
  await document.fonts.ready;

  ctx.font = `400 ${fontSize}px Mitr`;
  ctx.fillText(petName, textX, textY);
};
